

















































import Vue from 'vue';
import SaveData from '@/classes/saveData/saveData';
import Convert from '@/classes/convert';
import ShipMaster from '@/classes/fleet/shipMaster';
import EnemyMaster from '@/classes/enemy/enemyMaster';
import Ship from '@/classes/fleet/ship';
import ItemMaster from '@/classes/item/itemMaster';

export default Vue.extend({
  name: 'SaveDataTooltip',
  props: {
    value: {
      type: SaveData,
      required: true,
    },
  },
  data: () => ({
    ships1: [] as Ship[],
    ships2: [] as Ship[],
  }),
  computed: {
    editDate(): string {
      if (this.value.editedDate) {
        return Convert.formatDate(new Date(this.value.editedDate), 'yyyy/MM/dd HH:mm:ss');
      }
      return '';
    },
  },
  mounted() {
    if (!this.value.isDirectory) {
      // 編成復帰
      const items = this.$store.state.items as ItemMaster[];
      const ships = this.$store.state.ships as ShipMaster[];
      const enemies = this.$store.getters.getEnemies as EnemyMaster[];
      const manager = this.value.loadManagerData(items, ships, enemies);

      this.ships1 = manager.fleetInfo.fleets[0].ships.filter((v) => v.data.id > 0);
      if (manager.fleetInfo.isUnion) {
        this.ships2 = manager.fleetInfo.fleets[1].ships.filter((v) => v.data.id > 0);
      }
    }
  },
});
